import * as z from 'zod';

import { ApiExceptions, VarietyPropertyName } from './api-untyped-exceptions.ts';

function makeErrorSchema<Schema extends z.ZodType>(response: Schema) {
  return z.object({
    // TODO: error wasn't properly branded because the interceptors are called before branding.
    // [VarietyPropertyName]: z.literal(ApiExceptions.Error),
    request: z.object({
      response: z.string(),
    }),
    response: response.optional(),
    status: z.number(),
    message: z.string(),
  });
}
export type ApiError<Schema extends z.ZodType> = z.infer<ReturnType<typeof makeErrorSchema<Schema>>>;
export function makeApiError<Schema extends z.ZodType, Err extends ApiError<Schema>, Obj extends Omit<Err, typeof VarietyPropertyName>>(
  schema: Schema,
  obj: Obj,
): Err {
  // @ts-expect-error I don't know how to write the correct types
  return {
    ...obj,
    [VarietyPropertyName]: ApiExceptions.Error,
  };
}
export function isApiError<Schema extends z.ZodType>(arg: unknown, response: Schema): arg is ApiError<Schema> {
  return makeErrorSchema(response).safeParse(arg).success;
}

/**
 * Force cast error to ApiError without any validation.
 * @param error - any target
 * @param response
 * @deprecated Validate error type with `isApiError` instead.
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function unsafeCastToApiError<Schema extends z.ZodType>(error: unknown, response: Schema): ApiError<Schema> {
  return error as ApiError<Schema>;
}

const CancelSchema = z.object({
  [VarietyPropertyName]: z.literal(ApiExceptions.Cancel),
});
type ApiCancel = z.infer<typeof CancelSchema>;
export function makeApiCancel(): ApiCancel {
  return {
    [VarietyPropertyName]: ApiExceptions.Cancel,
  };
}
export function isApiCancel(arg: unknown): arg is ApiCancel {
  return CancelSchema.safeParse(arg).success;
}
